(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/netsales-and-cashback/assets/javascripts/net-sales.js') >= 0) return;  svs.modules.push('/components/racing/netsales-and-cashback/assets/javascripts/net-sales.js');
'use strict';

const {
  raceHasFinalResults,
  raceHasPreliminaryResults,
  raceNoLongerOpen,
  raceOngoing,
  raceNotYetOpen,
  drawOpen
} = svs.racing.common.statusUtil;
const gameTypes = svs.racing.common.constants.gameTypes;
const {
  useEffect,
  useState
} = React;
const {
  fetchTurnover
} = svs.racing.raceService;
const {
  gameTypeIsInOrder
} = svs.racing.common.util;
const NetSales = _ref => {
  let {
    currentDraw,
    race
  } = _ref;
  const [turnover, setTurnover] = useState({
    turnover: 0
  });
  useEffect(() => {
    if (currentDraw && currentDraw.userProduct) {
      fetchTurnover(race.raceId, currentDraw.userProduct, (err, turnover) => {
        if (err) {
          setTurnover(undefined);
        } else {
          setTurnover(turnover);
        }
      });
    }
  }, [currentDraw.userProduct, race.raceId]);
  const renderNetsales = () => {
    const showNetSales = turnover && parseInt(turnover.turnover, 10) > 0;
    const netSaleInfo = showNetSales ? 'Omsättning just nu' : 'Omsättning inte tillgänglig.';
    if (currentDraw && raceNoLongerOpen(race) && turnover) {
      return React.createElement("div", {
        className: "game-type-netsale no-margin-right"
      }, React.createElement("span", {
        className: "cash-left"
      }, "Oms\xE4ttning: "), React.createElement("span", {
        className: "game-type-netsale-amount-after"
      }, turnover.turnover, ' ', "kr"));
    } else if (currentDraw && turnover) {
      return React.createElement("div", {
        className: "game-type-netsale"
      }, React.createElement("div", {
        className: "game-type-netsale-header"
      }, netSaleInfo), React.createElement("span", {
        className: "game-type-netsale-amount"
      }, showNetSales ? "".concat(turnover.turnover, " kr") : React.createElement("br", null)));
    }
  };
  const renderJackpot = () => {
    if (currentDraw && turnover && turnover.jackpot && parseInt(turnover.jackpot, 10) > 0) {
      return React.createElement("div", {
        className: "game-type-netsale"
      }, React.createElement("div", {
        className: "game-type-netsale-header"
      }, currentDraw.gameType === gameTypes.TOPP5 ? 'Jackpot' : 'Extrapengar'), React.createElement("div", {
        className: "game-type-netsale-amount"
      }, turnover.jackpot, ' ', "kr"));
    }
  };
  const renderCashback = (gameType, distribution) => {
    switch (gameType) {
      case gameTypes.PLATS:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "R\xE4tt Plats:"), ' ', React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination), React.createElement("span", {
          className: "cash-right"
        }, "Odds:", ' ', React.createElement("span", {
          className: "cash-right-bold"
        }, distribution.odds)));
      case gameTypes.TOPP2:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "R\xE4tt Duo:"), ' ', React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination, ' '), React.createElement("span", {
          className: "cash-right"
        }, "Odds:", ' ', React.createElement("span", {
          className: "cash-right-bold"
        }, distribution.odds)));
      case gameTypes.RX2IO:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "R\xE4tt Duo Rak:"), ' ', React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination, ' '), React.createElement("span", {
          className: "cash-right"
        }, "Odds:\xA0", React.createElement("span", {
          className: "cash-right-bold"
        }, distribution.odds), React.createElement("span", null, distribution.count && "\n                  (".concat(svs.utils.format.Currency(distribution.count), " st)\n                "))));
      case gameTypes.RX2P:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "R\xE4tt 2 av 3:"), ' ', React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination, ' '), React.createElement("span", {
          className: "cash-right"
        }, "Odds:", ' ', React.createElement("span", {
          className: "cash-right-bold"
        }, distribution.odds)));
      case gameTypes.RX2P4:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "R\xE4tt 2 av 4:"), ' ', React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination, ' '), React.createElement("span", {
          className: "cash-right"
        }, "Odds:", ' ', React.createElement("span", {
          className: "cash-right-bold"
        }, distribution.odds)));
      case gameTypes.TOPP5:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, distribution.title), ' ', React.createElement("span", {
          className: "right"
        }, React.createElement("span", {
          className: "cash-right-bold"
        }, svs.utils.format.Currency(distribution.amount), ' ', "kr"), React.createElement("span", {
          className: "cash-right".concat(distribution.count ? ' margin-left' : '')
        }, "(", svs.utils.format.Currency(distribution.count), ' ', "st)")), React.createElement("div", null, React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination)));
      case gameTypes.RX4IO:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, distribution.title), ' ', React.createElement("span", {
          className: "right"
        }, React.createElement("span", {
          className: "cash-right-bold"
        }, svs.utils.format.Currency(distribution.amount), ' ', "kr"), React.createElement("span", {
          className: "cash-right".concat(distribution.count ? ' margin-left' : '')
        }, distribution.count && "\n                  (".concat(svs.utils.format.Currency(distribution.count), " st)\n                "))), React.createElement("div", null, React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination)));
      case gameTypes.RX3IOAO:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, distribution.title), ' ', React.createElement("span", {
          className: "right"
        }, React.createElement("span", {
          className: "cash-right-bold"
        }, svs.utils.format.Currency(distribution.amount), ' ', "kr"), React.createElement("span", {
          className: "cash-right".concat(distribution.count ? ' margin-left' : '')
        }, distribution.count && "\n                  (".concat(svs.utils.format.Currency(distribution.count), " st)\n                "))), React.createElement("div", null, React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination)));
      case gameTypes.VINNARE:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "R\xE4tt Vinnare:"), ' ', React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination), React.createElement("span", {
          className: "cash-right"
        }, "Odds:", ' ', React.createElement("span", {
          className: "cash-right-bold"
        }, distribution.odds)));
      case gameTypes.RX3AO:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "".concat(distribution.title, ": "), React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination)), ' ', React.createElement("span", {
          className: "right"
        }, "Odds:", ' ', React.createElement("span", {
          className: "cash-right-bold"
        }, svs.utils.format.Currency(distribution.odds)), React.createElement("span", {
          className: "cash-right".concat(distribution.count ? ' margin-left' : '')
        }, distribution.count && "\n                  (".concat(svs.utils.format.Currency(distribution.count), " st)\n                "))));
      case gameTypes.RX3IO:
        return React.createElement(React.Fragment, null, React.createElement("span", {
          className: "cash-left"
        }, "R\xE4tt Trippel Rak:"), ' ', React.createElement("span", {
          className: "cash-left-bold"
        }, distribution.combination, ' '), React.createElement("span", {
          className: "cash-right"
        }, "Odds:", React.createElement("span", {
          className: "cash-right-bold"
        }, distribution.odds), React.createElement("span", null, distribution.count && "\n                  (".concat(svs.utils.format.Currency(distribution.count), " st)\n                "))));
      default:
        return null;
    }
  };
  let flagDivider = false;
  const DividerNonRunners = props => {
    if (props.hasNonRunner && !flagDivider) {
      flagDivider = props.hasNonRunner;
      return React.createElement("div", {
        className: "margin-v-1 f-bold"
      }, "Rader med struken h\xE4st");
    }
    return null;
  };
  const netsalesAndTurnover = () => {
    if (currentDraw && currentDraw.distribution && currentDraw.distribution.length > 0) {
      return React.createElement("div", {
        className: "cashback-holder"
      }, React.createElement("div", {
        className: "cashback-frame"
      }, currentDraw.distribution.map(distribution => React.createElement("div", {
        className: "cashback-row",
        key: distribution.title + distribution.hasNonRunner + distribution.combination
      }, React.createElement(DividerNonRunners, {
        hasNonRunner: distribution.hasNonRunner
      }), renderCashback(currentDraw.gameType, distribution))), renderNetsales(), gameTypeIsInOrder(currentDraw.gameType) && currentDraw.distribution[0].stakeBase && React.createElement("div", {
        className: "cashback-stakebase"
      }, "Utdelningen g\xE4ller", ' ', currentDraw.distribution[0].stakeBase.split(',')[0], ' ', "kr radinsats")));
    }
    return 'Utdelningen visas efter att loppets resultat är fastställt';
  };
  if (!race || raceNotYetOpen(race)) {
    return null;
  }

  if (drawOpen(currentDraw)) {
    return React.createElement("div", {
      className: "game-type-netsale-container"
    }, renderNetsales(), renderJackpot());

  } else if (raceOngoing(race)) {
    return React.createElement(React.Fragment, null, React.createElement("div", null, "Utdelningen visas efter att loppets resultat \xE4r fastst\xE4llt."), renderNetsales());

  } else if (raceNoLongerOpen(race)) {
    if ((raceHasPreliminaryResults(race) || raceHasFinalResults(race)) && currentDraw) {
      return netsalesAndTurnover();
    }
  }

  return null;
};
svs.racing.netsales.NetSales = NetSales;

 })(window);